import { getFundamentalValue } from '../../../../utils/fundamentals';

export const getFieldValue = (fundamentals, field) => {
  return getFundamentalValue(fundamentals, field, 'value');
};

export const getWeeklyMarginRatio = (fundamentals) => {
  const purchases = getFieldValue(fundamentals, 'weeklyMarginPurchases');
  const sales = getFieldValue(fundamentals, 'weeklyMarginSales');
  if (typeof purchases !== 'number' || typeof sales !== 'number') {
    return null;
  }

  if (sales > 0) {
    return purchases / sales;
  }

  return 0;
};

export const getLendingFeeRatio = (prevClose, lendingFee) => {
  if (typeof lendingFee !== 'number' || typeof prevClose !== 'number') {
    return null;
  }

  if (prevClose > 0) {
    return (lendingFee / prevClose) * 100;
  }

  return 0;
};

export const getDifference = (value1, value2) => {
  const result = value1 - value2;
  if (isNaN(result)) {
    return null;
  }

  return result;
};

export const getMarginValue = (fundamentals, attribute) => {
  return getFundamentalValue(fundamentals, 'margin', attribute);
};
